<template>
  <div>
    <!-- List -->
    <div>
      <vs-table
        id="product_list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['feedback_create'])"
              @click="toggleAddModal"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>First Name</vs-th>
          <vs-th>Last Name</vs-th>
          <vs-th>Sangat Handle Name</vs-th>
          <vs-th>Mobile Number</vs-th>
          <vs-th>Feedback Date Time</vs-th>
          <vs-th>Detail</vs-th>
          <vs-th>Rating</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">{{ tr.user && tr.user.first_name ? tr.user.first_name : '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.user && tr.user.last_name ? tr.user.last_name : '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.user && tr.user.handle_name ? tr.user.handle_name : '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.user && tr.user.mobile_number ? tr.user.mobile_number : '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.feedback_date_time ? tr.feedback_date_time : 'N/A' }}</vs-td>
            <vs-td class="text-left cursor-pointer">
              <span class="cursor-pointer" @click="openDetailModal(tr)" v-tooltip="{ content: `View Feedback` }">
                {{ tr.detail || '-' }}
              </span>
            </vs-td>
            <vs-td class="text-left">
              <!-- Star Rating Implementation -->
              <span v-if="tr.star_rating && tr.star_rating > 0">
                <!-- Filled star for ratings -->
                <svg v-for="n in tr.star_rating" :key="n" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-yellow-800" fill="orange" viewBox="0 0 24 24">
                  <path d="M12 .587l3.668 7.429L24 9.458l-6 5.857L19.335 24 12 20.126 4.665 24 6 15.315 0 9.458l8.332-1.442L12 .587z" />
                </svg>
              </span>
              <span v-else>-</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <!-- Detail Modal -->
    <vs-popup :active.sync="isDetailModalActive" title="Feedback Details" button-accept="Close" @accept="isDetailModalActive = false" width="400px">
      <div v-if="selectedRecord" class="space-y-3">
        <!-- First Name -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">First Name:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.user.first_name || '-' }}</span>
        </div>

        <!-- Last Name -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Last Name:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.user.last_name || '-' }}</span>
        </div>

         <!-- Sangat Handle Name -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Sangat Handle Name:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.user.handle_name || '-' }}</span>
        </div>

        <!-- Mobile Number -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Mobile Number:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.user.mobile_number || '-' }}</span>
        </div>

        <!-- Feedback Date Time -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Feedback Date Time:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.feedback_date_time || '-' }}</span>
        </div>

        <!-- Detail -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Detail:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.detail || '-' }}</span>
        </div>

        <!-- Rating -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Rating:</span>
          <span v-if="selectedRecord.star_rating && selectedRecord.star_rating > 0" class="flex">
            <!-- Filled star for ratings -->
            <svg v-for="n in selectedRecord.star_rating" :key="n" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-yellow-800" fill="orange" viewBox="0 0 24 24">
              <path d="M12 .587l3.668 7.429L24 9.458l-6 5.857L19.335 24 12 20.126 4.665 24 6 15.315 0 9.458l8.332-1.442L12 .587z" />
            </svg>
          </span>
          <span v-else>-</span>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'FeedbackList',

  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Feedback',
    isDetailModalActive: false,
    selectedRecord: null
  }),

  computed: {
    ...mapState('feedback', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  methods: {
    ...mapActions('feedback', {
      get: 'get'
    }),

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    getData() {
      this.get({
        limit: this.length,
        page: this.page,
        search: this.search
      }).then(() => {
        this.$store.dispatch('feedback/getUnreadCount')
      })
    },

    openDetailModal(record) {
      this.selectedRecord = record
      this.isDetailModalActive = true
    }
  },

  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#product_list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#product_list > .con-vs-loading')
      }
    },

    page() {
      this.getData()
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
